import { AttachmentsData } from 'shell/models/act-wizard';
import { TypeFile } from 'practice/components/detail/form/accordion-attachments/form';

export const transformerDocument = (values?: AttachmentsData): TypeFile => {
  return {
    name: values?.nomeFile || '',
    idAllegato: values?.key?.idAllegato || undefined,
    raw: values?.oggettoAllegato || '',
    idAnscAllegato: values?.idAnscAllegato || undefined, // se presente il documento è stato inviato
    codStato: values?.codStato || '',
  } as TypeFile;
};
